import React, { useContext } from 'react'

import notify from 'tools/Notify'

function Clipboard({
  value,
  className = 'clear nowrap',
  children = <i className="f3 far fa-copy gray" />
}) {
  const [, notifyDispatch] = useContext(notify.Context)
  const clipboard = navigator.clipboard
  if (!clipboard) return null
  if (!value) return null
  return (
    <button
      className={className}
      onClick={() => {
        clipboard
          .writeText(value)
          .then(() => {
            notify.info(notifyDispatch, 'Copied to clipboard')
          })
          .catch(notify.onCatch(notifyDispatch))
      }}
    >
      {children}
    </button>
  )
}

export default Clipboard
